import React, { useEffect, useState } from "react";
import { Alert, Button, Checkbox, Drawer, Input, Tag } from "@stonelog/stonelog-design-system";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { getTrackingDeliveriesAutonomos, postTrackingDeliveryAutonomos, resetDeliveryAutonomosStates, trackingDeliveriesSelector } from "../../../../../../../features/senninha/trackingDeliveriesSlice";
import { getTicketsUninstall, ticketsSelector } from "../../../../../../../features/senninha/ticketSlice";
import machineError from "@assets/imgs/machine-error.svg";
import { useSelector, useDispatch } from "react-redux";
import { capitalizeAllFirstLetters } from "../../../../../../../consumingApi/services/helper";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { hubsSelector } from "../../../../../../../features/senninha/hubsSlice";
import filesGrey from "@assets/imgs/files-grey.svg";

import * as S from "./styles";


const FinishedAutonomosContent = ({ onOpenDeliveryAutonomosDrawer }) => {
    const [searchText, setSearchText] = useState('')
    const [filteredDeliveries, setFilteredDeliveries] = useState([])
    const [checkedList, setCheckedList] = useState([])
    const [checkboxOptions, setCheckboxOptions] = useState([])

    const {
        deliveriesAutonomos,
        statusGetDeliveriesAutonomos,
        errorGetDeliveriesAutonomos,
        statusPostDeliveriesAutonomos
    } = useSelector(trackingDeliveriesSelector)

    const {
        selectedHubInfos
    } = useSelector(hubsSelector);

    const {
        statusUninstall: statusGerarComprovante
    } = useSelector(ticketsSelector)

    const dispatch = useDispatch();

    const loading = statusGetDeliveriesAutonomos === 'pending'
    const checkAll = checkboxOptions.length === checkedList.length && checkedList.length
    const indeterminate = checkedList.length > 0 && checkedList.length < checkboxOptions.length

    const onCheckAllChange = (e) =>
        setCheckedList(e.target.checked ? checkboxOptions : [])

    const handleChangeCheckbox = (checkedValue) =>
        setCheckedList((p) => checkedList.find((item) => item === checkedValue) ?
            p.filter((item) => item !== checkedValue)
            : [...p, checkedValue]
        )

    // Temporariamente desativado: ainda não vamos permitir dar baixa por aqui.
    // const handleOssBaixa = () => {
    //     const payload = deliveriesAutonomos.reduce((res, item) => {
    //         if (checkedList.includes(item.reference_key)) {
    //             return [...res, ...item.oss.map((item2) => ({
    //                 id_os: item2.id_os,
    //                 servico: item2.servico,
    //                 terminal_entrada: item2.terminal_entrada,
    //                 horario_finalizado: item.horario_finalizado
    //             }))]
    //         }
    //         return res
    //     }, [])

    //     const refIds = deliveriesAutonomos.map((item) => item.reference_key)
    //     dispatch(postTrackingDeliveryAutonomos({ refIds, payload }))
    // }

    const handleGerarComprovante = () => {
        const idsOs = deliveriesAutonomos.reduce((res, item) => {
            if (checkedList.includes(item.reference_key)) {
                return [...res, ...item.oss.map(({ id_os }) => id_os)]
            }
            return res
        }, [])

        dispatch(getTicketsUninstall(idsOs))
    }

    useEffect(() => {
        if (filteredDeliveries?.length)
            setCheckboxOptions(filteredDeliveries.map(({ reference_key }) => reference_key))
    }, [filteredDeliveries])

    useEffect(() => {
        if (searchText) {
            const res = deliveriesAutonomos?.filter(({ id_atendimento, oss }) =>
                (id_atendimento.includes(searchText))
                || (oss.find(({ id_os }) => id_os.toString().includes(searchText)))
            )
            setFilteredDeliveries(res)
        } else setFilteredDeliveries(deliveriesAutonomos)
    }, [deliveriesAutonomos, searchText])

    useEffect(() => {
        if (statusPostDeliveriesAutonomos === 'fulfilled') {
            setCheckedList([])
        }
    }, [statusPostDeliveriesAutonomos])

    return (
        <>
            <Drawer.Body>
                {loading ?
                    <Drawer.Loading
                        loadingMessage="Carregando..."
                    />
                    :
                    errorGetDeliveriesAutonomos ?
                        <S.EmptyDrawer>
                            <img src={machineError} height={64} width={74} />
                            <p>
                                Houve um erro!
                            </p>
                            <Button
                                height="44px"
                                onClick={() => dispatch(getTrackingDeliveriesAutonomos(selectedHubInfos.children))}
                            >
                                <GingaIcon
                                    name="action-refresh"
                                    color="#fffff"
                                    size={18}
                                />
                                Atualizar lista
                            </Button>
                        </S.EmptyDrawer>
                        :
                        deliveriesAutonomos?.length ?
                            <>
                                <S.AllDeliveryDrawerContent>
                                    <S.HeaderDelivery>
                                        <Input
                                            label='Pesquisar'
                                            placeholder='Stonecode ou Nº da OS'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            size="small"
                                            suffixIcon={<GingaIcon name='search' color='#767F8D' size='18px' />}
                                            allowClear
                                        />
                                        <Button
                                            width="44px"
                                            height="44px"
                                            onClick={() => dispatch(getTrackingDeliveriesAutonomos(selectedHubInfos.children))}
                                        >
                                            <GingaIcon
                                                name="action-refresh"
                                                color="#fffff"
                                            />
                                        </Button>
                                    </S.HeaderDelivery>
                                    <S.DeliveryTopContent>
                                        <Checkbox
                                            label={`Selecionar tudo`}
                                            indeterminate={indeterminate}
                                            onChange={onCheckAllChange}
                                            checked={checkAll}
                                            size={24}
                                            onClick={(e) => e.target.blur()}
                                        />
                                    </S.DeliveryTopContent>

                                </S.AllDeliveryDrawerContent>

                                {filteredDeliveries?.map((delivery, i) => (
                                    <Drawer.Row
                                        key={i}
                                        onClick={() => {
                                            onOpenDeliveryAutonomosDrawer(delivery)
                                            dispatch(resetDeliveryAutonomosStates())
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Drawer.RowPrefix>
                                            <Checkbox
                                                size={24}
                                                value={delivery.reference_key}
                                                checked={checkedList.includes(delivery.reference_key)}
                                                onChange={(e) => handleChangeCheckbox(e.target.value)}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    e.target.blur()
                                                }}
                                            />
                                        </Drawer.RowPrefix>
                                        <Drawer.RowText
                                            text={capitalizeAllFirstLetters(delivery.cliente)}
                                            description={`${
                                                capitalizeAllFirstLetters(delivery.operador_logistico)
                                            } | ${
                                                delivery.oss.map(({ servico, id_os }) =>
                                                    ` ${capitalizeAllFirstLetters(servico)} (OS ${id_os})`)
                                            } | Lote ${delivery?.num_pedido || delivery?.lote}`}
                                        />

                                        <Drawer.RowActions>
                                            <Tag
                                                text={delivery?.horario_finalizado ?
                                                    `${format(new Date(delivery.horario_finalizado), "H:mm", {
                                                        locale: ptBR,
                                                    })}`
                                                    : 'Horário não informado'
                                                }
                                                type='default'
                                            />
                                        </Drawer.RowActions>
                                    </Drawer.Row>
                                ))}
                            </>
                        :
                        <S.EmptyDrawer>
                            <img src={filesGrey} />
                            <p>
                                Lista vazia.
                            </p>
                            <Button
                                height="44px"
                                onClick={() => dispatch(getTrackingDeliveriesAutonomos(selectedHubInfos.children))}
                            >
                                <GingaIcon
                                    name="action-refresh"
                                    color="#fffff"
                                    size={18}
                                />
                                Atualizar lista
                            </Button>
                        </S.EmptyDrawer>
                }
            </Drawer.Body>
            {checkedList.length ? (
                <Drawer.Footer>
                    <Button
                        type='primary'
                        height='52px'
                        onClick={handleGerarComprovante}
                        loading={statusGerarComprovante === 'pending'}
                        disabled={!checkedList.length}
                    >
                        <GingaIcon
                            name="printer"
                            color="#fff"
                            size={16}
                        />
                        Gerar comprovante ({checkedList.length})
                    </Button>
                </Drawer.Footer>
            ) : <></>}
        </>
    )
}

export default FinishedAutonomosContent;
